import { useQuery } from "@tanstack/react-query";
import { axiosInstance, validateUuid } from "../../utils";
import { WageImportJobItem } from "../models/WageImportJob";
import { queryKeys } from "../queryKeys";

export function useWageImportJobs(tenantId: string | undefined) {
    const axios = axiosInstance();

    return useQuery({
        ...queryKeys.wageImportJobs.byTenantId(tenantId ?? ""),
        queryFn: () => {
            return axios.get<WageImportJobItem[]>(`api/clients/${validateUuid(tenantId)}/wagejobs`).then(response => response.data);
        },
    });
}
